/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AtoNType } from './AtoNType';
import {
    AtoNTypeFromJSON,
    AtoNTypeFromJSONTyped,
    AtoNTypeToJSON,
} from './AtoNType';

/**
 * 
 * @export
 * @interface GetAtoNTypes200Response
 */
export interface GetAtoNTypes200Response {
    /**
     * 
     * @type {Array<AtoNType>}
     * @memberof GetAtoNTypes200Response
     */
    records?: Array<AtoNType>;
}

/**
 * Check if a given object implements the GetAtoNTypes200Response interface.
 */
export function instanceOfGetAtoNTypes200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetAtoNTypes200ResponseFromJSON(json: any): GetAtoNTypes200Response {
    return GetAtoNTypes200ResponseFromJSONTyped(json, false);
}

export function GetAtoNTypes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAtoNTypes200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(AtoNTypeFromJSON)),
    };
}

export function GetAtoNTypes200ResponseToJSON(value?: GetAtoNTypes200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(AtoNTypeToJSON)),
    };
}

